import { render, staticRenderFns } from "./SpaceData.vue?vue&type=template&id=5aba3ac7"
import script from "./SpaceData.vue?vue&type=script&lang=js"
export * from "./SpaceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports